import { ProjectPage } from '@/features/Transition360/ProjectPage';
import { projectIdParams } from '@/features/Transition360/routeParams';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/transition-360/projects/$projectId/')({
    params: projectIdParams,
    component: ProjectPageRoute,
});

function ProjectPageRoute() {
    const { projectId } = Route.useParams();
    return <ProjectPage projectId={projectId} />;
}
